import React from "react";

export default function Section12() {
  const services = [
    {
      title: "Official Shopify Partner",
      description: `As a certified Shopify Partner, Mean3 delivers development services built on proven platform standards. Our team follows best practices to ensure your store is secure, scalable, and optimized for performance, helping your business grow with stability and confidence.`,
    },
    {
      title: "Built for Real Shopping Behavior",
      description: `We structure Shopify stores based on how customers browse, compare, and decide. Our expert Shopify developers at Mean3, a Shopify development agency, design each section for clarity, trust, and conversion.`,
    },
  ];

  return (
    <div className="w-full Section11">
      <div className="md:w-[80%] w-[90%] text-center pt-5 mx-auto">
        <h1 className="text-[26px] md:text-[34px] leading-[40px] font-bold pb-[2%] my-[0.67em] -mb-[1%]">
          Shopify Development Agency Serving Texas Brands
        </h1>
        <p className="leading-[22px] text-[#373737] pb-[1%] text-sm md:text-base mb-[20px]">
          Our Shopify development services in Texas go beyond simply building online stores. We specialize in creating high-converting Shopify stores with fast, user-friendly designs, smooth navigation, and optimized structures that minimize drop-offs and enhance the shopping experience — turning more visitors into loyal paying customers.
        </p>
        

        <div className="boxes p-[2%_0%_3%_0%] flex justify-center flex-wrap w-[85%] mx-auto gap-x-[2%] gap-y-[19px] md:gap-y-[30px]">
          {services.map((service, index) => (
            <div
              key={index}
              className={`${index % 2 === 0 ? "bg-[#E42E35] text-white" : "bg-[#f5f5f5] text-[#373737]"} p-[10%] xs:p-[3%] xl:w-[45%] w-[90%] xs:w-[46%] rounded-[8px]`}
            >
              <h3 className="md:text-[25px] text-[20px] leading-[24px] font-bold md:leading-[30px] pb-[4%] my-[0.67em]">
                {service.title}
              </h3>
              <p className="mb-5 text-xs md:text-sm leading-[22px] font-open">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
